import { Component, OnInit, Injector, ViewChild, ViewEncapsulation, Injectable } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base'; 
import { ProgrammingsServiceProxy } from '@shared/service-proxies/service-proxies';
import { ProgrammingHelperService, IProgrammingSelected } from './programming-helper-service';

@Component({
    templateUrl: './programming-header.component.html',
    selector: '[programmingHeader]',
    encapsulation: ViewEncapsulation.None
})
@Injectable()
export class ProgrammingHeaderComponent extends AppComponentBase implements OnInit {
    
    programmingSelected: IProgrammingSelected = undefined;
    programmings = [];

    constructor(
        injector: Injector,
        private _programmingsService: ProgrammingsServiceProxy,
        private _programmingHelper: ProgrammingHelperService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.programmingSelected = this._programmingHelper.loadProgrammingSelected();
        this.loadProgramming();
        this.registerToEvents();
    }

    registerToEvents() {
        abp.event.on('app.programmingHeader.refresh', () => {
            this.loadProgramming();
        });
    }
    
    loadProgramming(): void {

        this.programmingSelected = this._programmingHelper.loadProgrammingSelected();

        this._programmingsService.getAll(
            undefined,
            undefined,
            undefined,
            0,
            3
        )          
        .subscribe(result => {

            this.programmings = result.items;

            if (!this.programmingSelected && result.totalCount > 0) {

                let event = result.items[0].programming.event;

                let programming: IProgrammingSelected = { 
                    id: event.id,
                    name: event.name,
                    userId: this.appSession.user.id,
                    programmingId: result.items[0].programming.id,
                    calendarId: result.items[0].programming.calendarId
                };

                this.save(programming)
            }
        });
    }

    chooseEvent(_programming): void {
        let programming: IProgrammingSelected = { 
            id: _programming.event.id,
            name: _programming.event.name,
            userId: this.appSession.user.id,
            programmingId: _programming.id,
            calendarId: _programming.calendarId
        };
        
        this.save(programming, true)
    }

    save(programming, reload?:boolean): void {

        this._programmingHelper.save(programming)
        this.programmingSelected = programming;

        if (reload) {
            window.location.reload();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/scientific/programming-header/programming-header.component.ts